<template>
  <div class="module-container">
    <div class="container">
      <h2 class="module-title">四大生态：重塑商业逻辑</h2>
      <p class="module-subtitle">通过四个维度的深度协同，实现项目从发掘到交付的全生命周期闭环管理。</p>
      <div class="ecosystem-cards">
        <div
          v-for="item in ecosystemList"
          :key="item.id"
          class="ecosystem-card"
          :class="item.theme"
        >
          <span class="card-index">{{ item.id }}</span>
          <div class="card-header">
            <div class="card-icon">
              <img :src="item.icon" :alt="item.title">
            </div>
            <div class="card-header-content">
              <h3 class="card-title">{{ item.title }}</h3>
              <p class="card-slogan">{{ item.slogan }}</p>
            </div>
          </div>

          <div class="detail-grid">
            <div
              v-for="detail in item.details"
              :key="detail.title"
              class="detail-card"
            >
              <div class="detail-title">
                <span class="detail-dot"></span>
                {{ detail.title }}
              </div>
              <p class="detail-text">{{ detail.text }}</p>
            </div>
          </div>

          <div class="value-bar">
            <span class="value-icon"></span>
            <span class="value-label">核心价值：</span>
            <span class="value-text">{{ item.values.join(' ・ ') }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import iconPartner from '@/assets/img/home/FourEcosystems/icon_hhr.png';
import iconService from '@/assets/img/home/FourEcosystems/icon_fwnl.png';
import iconSupply from '@/assets/img/home/FourEcosystems/icon_gyl.png';
import iconSolution from '@/assets/img/home/FourEcosystems/icon_jjfa.png';

export default {
  data () {
    return {
      ecosystemList: [
        {
          id: '01',
          theme: 'partner',
          icon: iconPartner,
          title: '合伙人生态（商务层）',
          slogan: '从“单打独斗”到“利益共享”',
          details: [
            {
              title: '供给方｜有交付能力',
              text: '打破人脉与地域壁垒，打通全域商务链路。依托平台流量优势，将自身交付能力辐射全国项目，跳出固有业务圈层，突破生意上限。'
            },
            {
              title: '需求方｜有人脉资源',
              text: '依托透明分配机制与平台交付实力，将人脉线索落地变现。放大资源价值、简化合作流程，让私域关系变成可持续盈利的商业资产。'
            }
          ],
          values: ['资源互通', '能力共享', '利益关系', '边界突破']
        },
        {
          id: '02',
          theme: 'service',
          icon: iconService,
          title: '服务能力生态（执行层）',
          slogan: '从“养人焦虑”到“弹性调度”',
          details: [
            {
              title: '供给方｜有闲置产能',
              text: '盘活施工、技术、运维冗余人力。接入平台订单池，承接异地支援、维保、施工项目，让闲置产能从成本负债转变为稳定营收资产。'
            },
            {
              title: '需求方｜有项目缺团队',
              text: '无需重资产自建团队，规避人力闲置、异地施工难等痛点。平台海量服务团队就近履约、按需调用，按单结算，降低运营成本。'
            }
          ],
          values: ['弹性调度', '降本增效', '就近履约', '稳定收益']
        },
        {
          id: '03',
          theme: 'supply',
          icon: iconSupply,
          title: '供应链生态（资源层）',
          slogan: '从“单点采购”到“集采共赢”',
          details: [
            {
              title: '采购合伙人',
              text: '依托平台集采体量直连源头厂商，压缩采购成本。平台官方背书加持，原厂技术、商务、方案全方位赋能，提高项目中标率，实现采购二次盈利。'
            },
            {
              title: '产品供应商',
              text: '打破地域获客局限，精准匹配平台内海量项目需求。无需高额拓客成本，一对一对接平台流量，结算规范回款高效，实现产品快速铺货。'
            }
          ],
          values: ['集采降本', '精准匹配', '资源整合', '高效周转']
        },
        {
          id: '04',
          theme: 'solution',
          icon: iconSolution,
          title: '解决方案生态（赋能层）',
          slogan: '从“资源堆砌”到“技术溢价”',
          details: [
            {
              title: '项目合伙人',
              text: '突破自身技术短板，共享全行业尖端解决方案。跨领域、多场景技术储备随时调用，不再因能力边界错失商机，拓宽业务赛道。'
            },
            {
              title: '技术服务商',
              text: '专注技术深耕研发，依托平台真实项目场景快速落地。借势平台渠道、商务、交付能力，降低市场推广成本，实现技术商业溢价。'
            }
          ],
          values: ['技术赋能', '能力互补', '场景落地', '溢价增长']
        }
      ]
    }
  }
};
</script>

<style lang="less" scoped>
.module-container {
  background: #fff;
  padding: 72px 0 86px;

  .container {
    max-width: @content-width;
    margin: 0 auto;
  }

  .module-title {
    margin: 0;
    text-align: center;
    font-size: 32px;
    line-height: 1.3;
    font-weight: 700;
    color: #1f2937;
  }

  .module-subtitle {
    margin: 18px 0 44px;
    text-align: center;
    font-size: 16px;
    line-height: 1.75;
    color: #94a3b8;
  }

  .ecosystem-cards {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 40px 36px;
  }

  .ecosystem-card {
    position: relative;
    border: 1px solid transparent;
    border-radius: 18px;
    padding: 26px 26px 24px;
    overflow: hidden;
    box-shadow: none;
    transition: transform 0.3s ease, box-shadow 0.3s ease;

    &:hover {
      transform: translateY(-6px);
      box-shadow: 0 24px 56px rgba(15, 23, 42, 0.12);
    }

    &.partner {
      background: linear-gradient(135deg, #fff8ef 0%, #ffffff 65%);
      border-color: #ffe6c9;

      .card-icon {
        background: linear-gradient(135deg, #ff9f43 0%, #ff7f0f 100%);
        box-shadow: 0 12px 28px rgba(255, 135, 38, 0.32);
      }

      .card-index,
      .value-text,
      .detail-title,
      .value-label,
      .value-icon {
        color: #ff8b1f;
      }

      .detail-card,
      .value-bar {
        border-color: #f8debf;
      }

      .value-bar {
        background: linear-gradient(90deg, rgba(255, 166, 72, 0.14) 0%, rgba(255, 245, 234, 0.95) 100%);
      }

      .detail-dot {
        background: #ff8b1f;
      }
    }

    &.service {
      background: linear-gradient(135deg, #eff7ff 0%, #ffffff 70%);
      border-color: #cfe4ff;

      .card-icon {
        background: linear-gradient(135deg, #4d97ff 0%, #0b68f2 100%);
        box-shadow: 0 12px 28px rgba(34, 118, 245, 0.3);
      }

      .card-index,
      .value-text,
      .detail-title,
      .value-label,
      .value-icon {
        color: #1b76ff;
      }

      .detail-card,
      .value-bar {
        border-color: #d7e8ff;
      }

      .value-bar {
        background: linear-gradient(90deg, rgba(39, 131, 255, 0.14) 0%, rgba(239, 247, 255, 0.95) 100%);
      }

      .detail-dot {
        background: #1b76ff;
      }
    }

    &.supply {
      background: linear-gradient(135deg, #effff8 0%, #ffffff 70%);
      border-color: #cdf5df;

      .card-icon {
        background: linear-gradient(135deg, #69db7c 0%, #08b66d 100%);
        box-shadow: 0 12px 28px rgba(17, 185, 109, 0.28);
      }

      .card-index,
      .value-text,
      .detail-title,
      .value-label,
      .value-icon {
        color: #11b56e;
      }

      .detail-card,
      .value-bar {
        border-color: #d5f4e2;
      }

      .value-bar {
        background: linear-gradient(90deg, rgba(34, 197, 94, 0.14) 0%, rgba(239, 255, 248, 0.95) 100%);
      }

      .detail-dot {
        background: #11b56e;
      }
    }

    &.solution {
      background: linear-gradient(135deg, #fcf7ff 0%, #ffffff 70%);
      border-color: #ecd9ff;

      .card-icon {
        background: linear-gradient(135deg, #9a6aff 0%, #7a44df 100%);
        box-shadow: 0 12px 28px rgba(131, 84, 224, 0.28);
      }

      .card-index,
      .value-text,
      .detail-title,
      .value-label,
      .value-icon {
        color: #8958ee;
      }

      .detail-card,
      .value-bar {
        border-color: #efdcff;
      }

      .value-bar {
        background: linear-gradient(90deg, rgba(157, 102, 255, 0.14) 0%, rgba(252, 247, 255, 0.95) 100%);
      }

      .detail-dot {
        background: #8958ee;
      }
    }
  }

  .card-index {
    position: absolute;
    top: 24px;
    right: 28px;
    font-size: 48px;
    line-height: 1;
    font-style: italic;
    font-weight: 300;
    opacity: 0.35;
    pointer-events: none;
  }

  .card-header {
    display: flex;
    align-items: center;
    gap: 22px;
    margin-bottom: 28px;
    padding-right: 86px;
  }

  .card-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 62px;
    height: 62px;
    border-radius: 14px;
    border: 1px solid rgba(255, 255, 255, 0.9);
    flex-shrink: 0;

    img {
      width: 34px;
      height: 34px;
      display: block;
      filter: brightness(0) invert(1);
    }
  }

  .card-title {
    margin: 0 0 10px;
    font-size: 23px;
    line-height: 1.35;
    font-weight: 700;
    color: #1f2937;
  }

  .card-slogan {
    margin: 0;
    font-family: @font-medium;
    font-size: 17px;
    line-height: 1.4;
    color: #374151;
  }

  .detail-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 16px 18px;
    margin-bottom: 16px;
  }

  .detail-card {
    min-height: 160px;
    background: rgba(255, 255, 255, 0.88);
    border: 1px solid;
    border-radius: 14px;
    padding: 18px 16px 16px;
    box-shadow: 0 8px 24px rgba(15, 23, 42, 0.04);
  }

  .detail-title {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 10px;
    font-size: 15px;
    line-height: 1.4;
    font-weight: 700;
  }

  .detail-dot {
    width: 9px;
    height: 9px;
    border-radius: 50%;
    flex-shrink: 0;
  }

  .detail-text {
    margin: 0;
    font-size: 14px;
    line-height: 1.8;
    text-align: justify;
    text-justify: inter-ideograph;
    color: #5f6b7a;
  }

  .value-bar {
    display: flex;
    align-items: center;
    min-height: 54px;
    border: 1px solid;
    border-radius: 12px;
    padding: 0 18px;
  }

  .value-icon {
    position: relative;
    width: 14px;
    height: 12px;
    margin-right: 10px;
    flex-shrink: 0;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 14px;
      height: 4px;
      border-radius: 4px 4px 0 0;
      background: currentColor;
    }

    &::after {
      content: '';
      position: absolute;
      left: 2px;
      top: 4px;
      width: 0;
      height: 0;
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-top: 7px solid currentColor;
    }
  }

  .value-label {
    margin-right: 8px;
    font-size: 15px;
    font-weight: 700;
    white-space: nowrap;
  }

  .value-text {
    font-family: @font-medium;
    font-size: 15px;
    line-height: 1.7;
  }
}
</style>
